"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var button_1 = require("./button");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        var _a = this.props, cancelButtonProps = _a.cancelButtonProps, cancelText = _a.cancelText, cancelVariant = _a.cancelVariant, children = _a.children, confirmLoading = _a.confirmLoading, footer = _a.footer, okButtonProps = _a.okButtonProps, okText = _a.okText, okVariant = _a.okVariant, onCancel = _a.onCancel, onOk = _a.onOk, restProps = __rest(_a, ["cancelButtonProps", "cancelText", "cancelVariant", "children", "confirmLoading", "footer", "okButtonProps", "okText", "okVariant", "onCancel", "onOk"]);
        return (react_1.default.createElement(StyledAntModal, __assign({}, restProps, { footer: footer || [
                react_1.default.createElement(button_1.Button, __assign({ key: "back", variant: okVariant || 'default', onClick: onCancel }, cancelButtonProps), cancelText || 'Cancel'),
                react_1.default.createElement(button_1.Button, __assign({ key: "submit", loading: confirmLoading, onClick: onOk, variant: cancelVariant || 'primary' }, okButtonProps), okText || 'OK')
            ] }), children));
    };
    return Modal;
}(react_1.default.Component));
exports.Modal = Modal;
var StyledAntModal = styled_components_1.default(antd_1.Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .ant-modal-close {\n        display: none;\n    }\n    .ant-modal-header {\n        background-color: ", ";\n        border-bottom: 1px solid ", ";\n        padding: ", ";\n    }\n    .ant-modal-body {\n        padding: ", ";\n    }\n    .ant-modal-footer {\n        border-top: none;\n        text-align: left;\n        padding: ", ";\n    }\n"], ["\n    .ant-modal-close {\n        display: none;\n    }\n    .ant-modal-header {\n        background-color: ", ";\n        border-bottom: 1px solid ", ";\n        padding: ", ";\n    }\n    .ant-modal-body {\n        padding: ", ";\n    }\n    .ant-modal-footer {\n        border-top: none;\n        text-align: left;\n        padding: ", ";\n    }\n"])), function (props) { return props.theme.palette.background.light; }, function (props) { return props.theme.palette.border.main; }, function (props) { return props.theme.spacing.md; }, function (props) { return props.theme.spacing.md; }, function (props) { return props.theme.spacing.md; });
var templateObject_1;
//# sourceMappingURL=Modal.js.map